<div>
  <h2 mat-dialog-title class="text-center">Take a photo</h2>
  <mat-divider class="yellow-divider"></mat-divider>

  <mat-dialog-content class="text-center">
    <div class="webcam-wrapper">
      <webcam
        [trigger]="triggerObservable"
        [width]="320"
        [height]="240"
        (imageCapture)="handleImage($event)"
        [videoOptions]="{ facingMode: 'user' }"
      ></webcam>
    </div>

    <button mat-flat-button (click)="takeSnapshot()" style="margin-top: 10px" class="btn-blue">
      Take a photo
    </button>

    @if (compressedImage) {
      <div>
        <br />
        <label>Preview Photo</label>
        <img [src]="compressedImage" class="preview-selfie" />
      </div>
    }

    <!-- Hidden canvas used for compression -->
    <canvas #canvas width="320" height="240" style="display: none"></canvas>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button
      mat-flat-button
      [disabled]="isUploading"
      (click)="onHandleSubmit()"
      class="btn-with-spinner btn-blue"
      style="margin-right: 10px"
      >
      SUBMIT
      @if (isUploading) {
        <span class="spinner-overlay">
          <span class="spinner"></span>
        </span>
      }
    </button>
    <button
      mat-flat-button
      mat-dialog-close
      (click)="this.dialogRef.close(false)"
      class="btn-grey"
      >
      CANCEL
    </button>
  </mat-dialog-actions>
</div>
